import { ApiClient } from '@website/lib/api';

export const notificationsService = {
  /**
   * List notifications for the current user
   */
  async listNotifications(params?: { read?: boolean; limit?: number; cursor?: string }) {
    return ApiClient.listNotifications({
      read: params?.read,
      limit: params?.limit,
      cursor: params?.cursor
    });
  },

  /**
   * Get unread notification count
   */
  async getUnreadCount() {
    return ApiClient.getUnreadCount();
  },

  /**
   * Mark a notification as read
   */
  async markAsRead(id: string) {
    return ApiClient.markAsRead(id);
  },

  /**
   * Mark all notifications as read
   */
  async markAllAsRead() {
    return ApiClient.markAllAsRead();
  },

  /**
   * Delete a notification
   */
  async deleteNotification(id: string) {
    return ApiClient.deleteNotification(id);
  },

  /**
   * Get notification preferences
   */
  async getPreferences() {
    return ApiClient.getNotificationPreferences();
  },

  /**
   * Update or create notification preferences
   */
  async updatePreferences(preferences: {
    preferences?: Record<string, { email?: boolean; sms?: boolean }>;
    upcomingReminderOffsetMinutesOverride?: number;
  }) {
    return ApiClient.upsertNotificationPreferences({
      preferences: preferences.preferences,
      upcomingReminderOffsetMinutesOverride: preferences.upcomingReminderOffsetMinutesOverride
    });
  }
};
